import TitleBarMenuItem from "../../../components/layout/title_bar/TitleBarMenuItem";
import { useCreateCollection, useGetCollections } from "../../../api/query_hooks";
import TitleBarSpacer from "../../../components/layout/title_bar/TitleBarSpacer";
import TitleBarTitle from "../../../components/layout/title_bar/TitleBarTitle";
import TitleBarMenu from "../../../components/layout/title_bar/TitleBarMenu";
import Thumbnail from "../../../components/images/thumbnail/Thumbnail";
import TitleBar from "../../../components/layout/title_bar/TitleBar";
import TagInput from "../../../components/forms/tag_input/TagInput";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import Panel from "../../../components/layout/panel/Panel";
import { useEffect, useRef, useState } from "react";

const CollectionGallery = () => {
    
    const collectionsQuery = useGetCollections();


    return (
        <Panel>
            <TitleBar className="bg-dark my-2 rounded">
                <TitleBarSpacer width={3} />
                <TitleBarTitle>My Collections</TitleBarTitle>
                <TitleBarMenu>
                    <TitleBarMenuItem>
                        <box-icon color='white' name='select-multiple'></box-icon>
                        <span>Select</span>
                    </TitleBarMenuItem>
                </TitleBarMenu>
            </TitleBar>
            {collectionsQuery.isLoading && 
                <div className="bg-black d-flex justify-content-center align-items-center container">
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {collectionsQuery.isError && <></>}
            {collectionsQuery.isSuccess &&
                <div className="d-flex flex-wrap w-100 p-2">
                    {(collectionsQuery.isSuccess) &&
                    collectionsQuery.data?.data.map((collection, index) => {
                        return(
                            <Thumbnail
                                key={index}
                                as="link"
                                to={'./'+collection.code}
                                src={process.env.PUBLIC_URL+"/default_collection.png"}
                                className="p-1 w-33 w-lg-25 border-black border-2 rounded-3 overflow-hidden"
                            />
                        )
                    })}
                </div>
            }
            <AddCollectionButton />
        </Panel>
    );
}


const AddCollectionButton = () => {
    const [show, setShow] = useState(false);

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [tags, setTags] = useState([]);

    const submitButtonRef = useRef();
    
    const mutation = useCreateCollection();

    const createCollection = (e) => {
        e.preventDefault();

        // const fd = new FormData();
        // fd.append("title", title);
        // fd.append("description", description);
        // tags.forEach((tag, _) => {
        //     fd.append("tags[]", tag);
        // });

        mutation.mutate({title: title, description: description, tags: tags});

        setShow(false);
    };

    useEffect(() => {
        if(mutation.isSuccess && !mutation.isError) {
            setShow(false);
        }
    }, [mutation.isSuccess, mutation.isError]);


    return (
        <>
            <Modal size="lg" show={show} fullscreen="md-down" centered onHide={() => setShow(false)}>
                <Modal.Header className="bg-dark rounded-md-top" closeButton>
                    <Modal.Title>Add new Collection</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark">
                    <Form encType="multipart/form-data" onSubmit={createCollection} >

                        <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="titleBox" >
                            <Form.Label className="ms-3">Title</Form.Label>
                            <Form.Control className="bg-darker" type="text" placeholder="Title of the collection" onChange={e => setTitle(e.target.value)} aria-describedby="title" />
                        </Form.Group>

                        <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="descriptionBox" >
                            <Form.Label className="ms-3">Description</Form.Label>
                            <Form.Control className="bg-darker" as={"textarea"} placeholder="Brief descrption of the collection" onChange={e => setDescription(e.target.value)} aria-describedby="description" />
                        </Form.Group>

                        <div className="d-flex flex-column">
                            {/* <ImageUploader label="Add images" className="d-flex flex-column mt-2 mb-3 ms-md-3 pe-md-4 col-md-12" images={images} setImages={setImages} fileLimit={8} /> */}
                            <TagInput className="mb-3 ms-md-3 pe-md-4 col-12" tags={tags} setTags={setTags} />
                        </div>

                        <Button type="submit" className="hidden" ref={submitButtonRef} />
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer className="bg-dark justify-content-between gap-2 rounded-md-bottom">
                    <Button variant="dark" className="border-secondary" onClick={() => setShow(false)} >
                        <span>Cancel</span>
                    </Button>
                    <Button variant="warning" className="px-4 px-lg-3" type="button" onClick={() => submitButtonRef.current.click()} aria-describedby="save" disabled={mutation.isFetching}>
                        {mutation.isFetching && <Spinner size="sm" animation="border" role="status" />}
                        {!mutation.isFetching && <span className="text-dark">Save</span>}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Button variant="link" className="position-absolute bottom-0 end-0 d-flex p-0 m-5" onClick={() => setShow(true)} aria-describedby="new collection" >
                <box-icon name='plus-circle' size='lg' type='solid' color='#ffc107' ></box-icon>
            </Button>
        </>
    );
}


export default CollectionGallery;